import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo-head";
import Packages from "@/pages/Packages";

export const Route = createFileRoute("/pricing")({
  component: Packages,
  head: () =>
    pageHead({
      title: "Contractor Website & SEO Pricing | Seattle, WA | jaik",
      description: "Contractor website and local SEO pricing for Seattle and western Washington. Compare monthly plans or book a call for custom work.",
      path: "/pricing",
    }),
});
